<template>
  <div class="send-record">
    <div class="header">
      <div class="count-container">
        <i class="el-icon-chat-dot-round"></i>
        <div>
          <div class="title">当前余额（条）</div>
          <div class="count">{{ totalData.residue }}</div>
        </div>
      </div>
      <div class="count-container">
        <i class="el-icon-chat-dot-round"></i>
        <div>
          <div class="title">今日发送（条）</div>
          <div class="count">{{ totalData.sendnumber }}</div>
        </div>
      </div>
      <div class="count-container">
        <i class="el-icon-chat-dot-round"></i>
        <div>
          <div class="title">总条数</div>
          <div class="count">{{ totalData.all }}</div>
        </div>
      </div>
    </div>
    <div class="search">
      <el-select v-model="searchInfo.status" placeholder="是否成功" clearable>
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="time"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="timestamp"
        :clearable="false"
        :default-time="['00:00:00', '23:59:59']"
        @change="handleChange"
      >
      </el-date-picker>
      <el-button type="three" @click="getLists({ type: 'search' })"
        >筛选</el-button
      >
      <el-button type="three" @click="resetSearchInfo">重置</el-button>
      <el-button type="three" @click="getLists({ e: 1 })">导出</el-button>
    </div>
    <el-table
      :data="recordList"
      style="width: 100%"
      :header-cell-style="{
        background: '#F0F3F7',
        color: '#39475B',
        'text-align': 'center',
      }"
      :cell-style="{
        background: '#FCFDFF',
        'font-size': '14px',
        color: '#8998AC',
        'text-align': 'center',
      }"
    >
      <el-table-column prop="id" label="短信ID" width="180"> </el-table-column>
      <el-table-column prop="save_time" label="发送时间" width="180">
      </el-table-column>
      <el-table-column prop="mobile" label="手机号"> </el-table-column>
      <el-table-column prop="status" label="是否成功">
        <template slot-scope="scope">{{
          getStatusText(scope.row)
        }}</template></el-table-column
      >
      <el-table-column prop="content" label="短信内容"> </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="10"
      layout="total, prev, pager, next, jumper"
      :total="total"
      prev-text="上一页"
      next-text="下一页"
      v-if="total > 10"
    />
  </div>
</template>

<script>
  import { getRecordList, getCount } from '@/api/messageManager'
  import { getCompletionUrl } from '@/utils/index'
  export default {
    data() {
      return {
        options: [
          {
            label: '成功',
            value: 1,
          },
          {
            label: '失败',
            value: 2,
          },
        ],
        recordList: [],
        time: '',
        currentPage: 1,
        searchInfo: {
          start_time: '',
          end_time: '',
          status: '',
        },
        total: 0,
        totalData: {
          count: 0,
          residue: 0,
          all: 0,
        },
      }
    },
    mounted() {
      this.getLists({})
      this.getCount()
    },
    computed: {
      getStatusText() {
        return ({ status }) => (status == 1 ? '成功' : '失败')
      },
    },
    methods: {
      async getLists({ type, e = 0 }) {
        if (type) {
          this.currentPage = 1
        }
        const res = await getRecordList({
          page: this.currentPage,
          ...this.searchInfo,
          export: e,
        })
        if (e && res.code != -1) {
          window.location.href = getCompletionUrl(res.data)
        } else {
          this.recordList = res.data.list
          this.total = res.data.total
        }
      },
      async getCount() {
        const res = await getCount()
        this.totalData = res.data
      },
      handleCurrentChange() {
        this.getLists({})
      },
      /**
       * 选择时间改变时
       */
      handleChange(e) {
        if (e == null) {
          this.searchInfo = {
            start_time: '',
            end_time: '',
          }
        } else {
          this.searchInfo.start_time = parseInt(e[0]) / 1000
          this.searchInfo.end_time = parseInt(e[1]) / 1000
        }
      },
      resetSearchInfo() {
        this.searchInfo = {
          start_time: '',
          end_time: '',
          status: '',
        }
        this.time = ''
        this.getLists({ type: 'search' })
      },
    },
  }
</script>
<style lang="scss">
  .send-record {
    .header {
      display: flex;
      .count-container {
        margin: 0 20px 20px 0;
        display: flex;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 187px;
        height: 99px;
        color: #333;
        background: #f0f3f7;
        border-radius: 10px;
        .title {
          font-size: 14px;
        }
        .count {
          margin-top: 10px;
          font-size: 28px;
        }
        .el-icon-chat-dot-round {
          margin-right: 10px;
          color: #409eff;
          font-size: 50px;
        }
      }
    }
    .search {
      display: flex;
      justify-content: flex-end;
    }
    .el-date-editor {
      margin: 0 10px 10px 10px;
    }
  }
</style>
